import { createSlice, PayloadAction } from '@reduxjs/toolkit';
// Import Types
import type { PartnerCurrency, PartnerSettings } from 'types';

export interface PartnerSettingsState {
    data: Nullable<PartnerSettings>;
    partnerCurrencies: PartnerCurrency[];
}

const initialState: PartnerSettingsState = {
    data: null,
    partnerCurrencies: [],
};

export const partnerSettingsSlice = createSlice({
    name: 'partnerSettings',
    initialState,
    reducers: (create) => ({
        getPartnerSettingsSuccess: create.reducer((state, { payload }: PayloadAction<PartnerSettings>) => {
            state.data = payload;
        }),

        setPartnerCurrencies: create.reducer(
            (state, { payload }: PayloadAction<PartnerSettingsState['partnerCurrencies']>) => {
                state.partnerCurrencies = payload;
            },
        ),

        resetPartnerSettings: create.reducer((state) => {
            state.data = null;
            state.partnerCurrencies = [];
        }),
    }),
    selectors: {
        selectPartnerSettings: (partnerSettings) => partnerSettings.data,

        selectPartnerId: (partnerSettings) => partnerSettings.data?.PartnerId,

        selectPartnerSettingsSubscription: (partnerSettings) => partnerSettings.data?.Subscription,

        selectSubscriptionColumns: (partnerSettings) => partnerSettings.data?.Subscription?.Columns,

        selectNonCustomerMinPeriod: (partnerSettings) => partnerSettings.data?.NonCustomerCommunicationMinPeriod,

        selectPartnerDataSourceId: (partnerSettings) => partnerSettings.data?.PartnerDataSourceId,

        selectPartnerCurrencies: (partnerSettings) => partnerSettings.partnerCurrencies,

        selectWarningThresholdPercentage: (partnerSettings) => partnerSettings.data?.WarningThresholdPercentage,

        selectPartnerDateFormats: (partnerSettings) => partnerSettings.data?.DataFormats,
    },
});

export const { getPartnerSettingsSuccess, setPartnerCurrencies, resetPartnerSettings } = partnerSettingsSlice.actions;
export const {
    selectNonCustomerMinPeriod,
    selectPartnerCurrencies,
    selectPartnerSettings,
    selectPartnerId,
    selectPartnerSettingsSubscription,
    selectPartnerDataSourceId,
    selectSubscriptionColumns,
    selectWarningThresholdPercentage,
    selectPartnerDateFormats,
} = partnerSettingsSlice.selectors;
